// extracted by mini-css-extract-plugin
module.exports = {"card-margin":"DriverOrders_card-margin__3WNpE","card-content":"DriverOrders_card-content__39D6y","info":"DriverOrders_info__3yjTF","icon":"DriverOrders_icon__2RnoI"};